import { useClientContext } from 'context/ClientContext';

export function useCustomFavicon(): void {
    const position = document.getElementById('favicon_place');
    const { favicon } = useClientContext();
    const faviconString = favicon?.join('');

    if (position && position.outerHTML && faviconString.length) {
        position.outerHTML = faviconString;
    }
}
